export default __webpack_public_path__ + "static/media/0000..0002.edc04c58.png";